import { AutomationRuleEnums } from "models/enums";
import LocalizationHelperInstance from "./localizationHelper";
import { WintSuperkollAPIModelCustomerAutomationsCommon as AutomationAPIModel } from "wint-api-client/dist/types";

const AutomationRuleTypeHelper = {
  getTranslatedRuleTypeText: (type: AutomationRuleEnums.AutomationRuleType) =>
    LocalizationHelperInstance.getTranslatedEnumValue("AutomationRule.RuleType", type),

  getRuleTypeTextByApiTypeAndSubType: (
    ruleType: AutomationAPIModel.RuleType,
    subType: AutomationAPIModel.RuleSubType
  ) => {
    return AutomationRuleTypeHelper.getTranslatedRuleTypeText(
      AutomationRuleTypeHelper.getRuleTypeEnumByApiTypeAndSubType(ruleType, subType)
    );
  },

  getRuleTypeEnumByApiTypeAndSubType: (
    ruleType: AutomationAPIModel.RuleType,
    subType: AutomationAPIModel.RuleSubType
  ) => {
    if (ruleType === AutomationAPIModel.RuleType.Receipts && subType === AutomationAPIModel.RuleSubType.WintCard)
      return AutomationRuleEnums.AutomationRuleType.ReceiptDraft;

    return AutomationRuleEnums.AutomationRuleType.Unknown;
  },

  getApiRuleSubTypeByRuleTypeEnum: (ruleType: AutomationRuleEnums.AutomationRuleType) => {
    switch (ruleType) {
      case AutomationRuleEnums.AutomationRuleType.ReceiptDraft:
        return AutomationAPIModel.RuleSubType.WintCard;
      default:
        return AutomationAPIModel.RuleSubType.Unknown;
    }
  },
};

export default AutomationRuleTypeHelper;
